import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotTopics from "./components/HotTopics";
import Works from "./components/Works";
import Discussion from "./components/Discussion";
import Circles from "./components/Circles";
import Stats from "./components/Stats";
import FAQ from "./components/FAQ";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { faqs } from "@/mocks/community";

export default function Home() {
  return (
    <div id="top" className="bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                name: "腐漫网",
                url: "https://aluhealth.cn",
                inLanguage: "zh-CN",
                description:
                  "腐漫网腐女社区入口，腐漫画网同好讨论与BL圈子互动平台。",
                potentialAction: {
                  "@type": "SearchAction",
                  target: "https://aluhealth.cn/#topics",
                  "query-input": "required name=search_term_string",
                },
              },
              {
                "@type": "Organization",
                name: "腐漫网",
                description:
                  "面向腐向内容爱好者与同好人群的互动社区平台，提供热门话题、作品讨论、粉丝圈子与同好交流。",
              },
              {
                "@type": "FAQPage",
                mainEntity: faqs.map((f) => ({
                  "@type": "Question",
                  name: f.q,
                  acceptedAnswer: { "@type": "Answer", text: f.a },
                })),
              },
            ],
          }),
        }}
      />

      <Navbar />
      <main>
        <Hero />
        <HotTopics />
        <Works />
        <Discussion />
        <Circles />
        <Stats />
        <FAQ />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}